import type { PersistedState } from "@aus-property/core";
import { authJsonHeaders, getAccessToken } from "@/integrations/cloud/authService";
import { requestCloudApi } from "@/integrations/cloud/cloudApiClient";
import type { CloudIdentity } from "@/integrations/cloud/authService";

export const pushPortfolioBackup = async (
  identity: CloudIdentity,
  state: PersistedState
): Promise<void> => {
  void identity;
  const token = await getAccessToken();
  if (!token) {
    throw new Error("Sign in to back up your portfolio.");
  }

  await requestCloudApi("/backup/push", {
    method: "POST",
    headers: await authJsonHeaders(),
    body: JSON.stringify({
      payload: state
    })
  });
};

export const pullPortfolioBackup = async (
  identity: CloudIdentity
): Promise<unknown | null> => {
  void identity;
  const token = await getAccessToken();
  if (!token) {
    throw new Error("Sign in to restore your backup.");
  }

  const payload = await requestCloudApi<{ payload: unknown | null }>(
    "/backup/pull",
    {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  );

  return payload.payload ?? null;
};
